import { useTinyHost } from "@tiny/host-contract";
import React from "react";
import { Button, Grid, Tooltip, Typography } from "@tiny/components";
import Filter from "@tiny/icons/generated/Filter";
import Info from "@tiny/icons/generated/Info";
import TrashFull from "@tiny/icons/generated/TrashFull";
import { HeaderComponentProps } from "../../SearchPanel/SearchPanel.types";
import { useSegmentListView } from "../SegmentList.context";
import AudienceSummaryDialog from "../../AudienceSummaryDialog";
import { FETCH_AND_SEND_TRAFFIC_SHAPING } from "../../../constants";

function SegmentListHeader(props: HeaderComponentProps) {
  const { selectedCount, onDeselectAll } = props;

  const {
    enableSelectionActions,
    openDeleteDialog,
    openFilters,
    isAudienceSummaryOpen,
    handleCloseAudienceSummary,
    handleOpenAudienceSummary,
    selectedSegmentIds,
  } = useSegmentListView();

  const { capabilities } = useTinyHost();
  const campaignWorkflowType = capabilities.campaignWorkflowType;

  return (
    <div>
      <Grid container alignItems="center" spacing={4}>
        {enableSelectionActions &&
          campaignWorkflowType === FETCH_AND_SEND_TRAFFIC_SHAPING && (
            <Grid item>
              <Tooltip
                arrow
                title={
                  selectedCount === 0
                    ? "Select one or more segments to view an audience summary"
                    : "View a summary of the selected segments"
                }
              >
                <span>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleOpenAudienceSummary}
                    disabled={selectedCount === 0}
                  >
                    Audience Summary
                  </Button>
                </span>
              </Tooltip>
            </Grid>
          )}
        {enableSelectionActions && selectedCount > 0 && (
          <>
            <Grid item>
              <Button
                variant="outlined"
                color="red"
                endIcon={<TrashFull />}
                onClick={openDeleteDialog}
              >
                Delete
              </Button>
            </Grid>
            <Grid item>
              <Button variant="text" noPadding onClick={onDeselectAll}>
                Deselect all
              </Button>
            </Grid>
            <Grid item>
              <Typography color="grey" tone={600} variant="body2">
                {selectedCount} selected
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
      <AudienceSummaryDialog
        open={isAudienceSummaryOpen}
        onClose={handleCloseAudienceSummary}
        segmentIds={selectedSegmentIds}
      />
    </div>
  );
}

export default SegmentListHeader;
